// extracted by mini-css-extract-plugin
module.exports =  {"jobCardExperience":"JobExperience-module_jobCardExperience_fd4da","experienceIcon":"JobExperience-module_experienceIcon_d7307"};